var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneMessageGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.9 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1fba9c;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xDCzenet_telefonra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23.1 34.25 29.31 28.03 21.99 28.03 21.99 15.79 44.9 15.79 44.9 28.03 34.38 28.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.81,
    y1: 22.09,
    x2: 38.48,
    y2: 22.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.99,
    y1: 22.09,
    x2: 32.66,
    y2: 22.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.45,
    y1: 5.72,
    x2: 23.54,
    y2: 5.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.01,
    y1: 5.72,
    x2: 12.68,
    y2: 5.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.34,37.32V57.91A3.1,3.1,0,0,1,31.24,61H4.1A3.1,3.1,0,0,1,1,57.91V4.1A3.1,3.1,0,0,1,4.1,1H31.24a3.1,3.1,0,0,1,3.1,3.1v8.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.01,
    y1: 55.7,
    x2: 33.83,
    y2: 55.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMessageGreen);
export default __webpack_public_path__ + "static/media/phoneMessageGreen.426343c8612003b740a0aa595cf30505.svg";
export { ForwardRef as ReactComponent };